import './Insights.css'

import React, { useEffect, useMemo } from 'react'
import { Outlet } from 'react-router-dom'

import { IS_ARTIST } from '@disco/constants/FeatureTypes'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { resetParams } from '@disco/state-management/actions/StatsActions'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'

import PageLayout from 'components/ui/page-layout'

import { useDispatch } from 'hooks/use-redux'

import InsightsDisabledAlert from './InsightsDisabledAlert'
import InsightsRecipientsLoader from './recipients/loader'

type Props = {
  disabled: boolean
  children?: React.ReactNode
}

const Insights = ({ disabled, children }: Props) => {
  const dispatch = useDispatch()
  const isArtist: boolean = useFeatureEnabled(IS_ARTIST)
  const NAV_ITEMS = useMemo(() => {
    let items = [
      {
        label: 'Recipients analytics',
        link: '/insights/recipients',
      },
    ]

    if (!isArtist) {
      items = [
        ...items,
        {
          label: 'Team analytics',
          link: '/insights/team',
        },
        {
          label: 'Reports',
          link: '/insights/reports',
        },
      ]
    }

    return items
  }, [isArtist])
  useEffect(() => {
    dispatch(sendMixpanelEvent('Open analytics'))
    InsightsRecipientsLoader.preload()
    return () => {
      dispatch(resetParams())
    }
  }, [])
  return (
    <div className="Page">
      <div className="Page_Content">
        {disabled && (
          <div className="Insights-alert">
            <InsightsDisabledAlert />
          </div>
        )}
        <PageLayout title="Insights" nav={NAV_ITEMS}>
          {children}
          <Outlet />
        </PageLayout>
      </div>
    </div>
  )
}

export default React.memo<Props>(Insights)
